"use strict";

require("core-js/modules/es6.object.create.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ArgumentOutOfRangeErrorImpl = function () {
  function ArgumentOutOfRangeErrorImpl() {
    Error.call(this);
    this.message = 'argument out of range';
    this.name = 'ArgumentOutOfRangeError';
    return this;
  }

  ArgumentOutOfRangeErrorImpl.prototype = Object.create(Error.prototype);
  return ArgumentOutOfRangeErrorImpl;
}();

exports.ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;